import React from 'react'

const Logo = () => (
  <svg viewBox="0 0 72.09 83.14">
    <defs>
      <clipPath id="clip-path" transform="translate(-268.8 -150.84)">
        <rect width="612" height="612" />
      </clipPath>
    </defs>
    <title>Asset 1128</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            d="M302.36,158.73v-7.89H276.61v7.89h8.11v56.44a23.11,23.11,0,0,1-.57,5.84,5,5,0,0,1-2,3,8.16,8.16,0,0,1-4.39.94,27.23,27.23,0,0,1-6.64-.92V233a25.62,25.62,0,0,0,7.31,1q8.35,0,12.09-4.34t3.74-14.93v-56Z"
            transform="translate(-268.8 -150.84)"
          />
          <path
            d="M329.55,177.44a8.77,8.77,0,0,1-5.12,3.69,32.59,32.59,0,0,1-9.33,1.08h-5.92V158.73h6.59q8.44,0,11.93,2.75t3.49,8.67a13.76,13.76,0,0,1-1.64,7.29m8.9-18.27a14.68,14.68,0,0,0-8-6.28q-5.61-2.05-15.14-2H291.71v7.89h7.9v47.49h-7.9v7.9h25.7v-7.9h-8.23V189.85h8.32q12.72-.09,18.05-5.46t5.34-14q0-7-2.44-11.19"
            transform="translate(-268.8 -150.84)"
          />
        </g>
        <rect width="12.6" height="7.97" />
      </g>
    </g>
  </svg>
)

export default Logo
